<script setup>
import { onMounted, computed, watch, ref } from 'vue';
import { useBasicosProjetos } from '@/modules/projeto/composables/useProjeto';

const props = defineProps({
    projetoId: String,
    erro: {
        type: String,
        default: null
    },
    modelValue: {
        type: Number,
        default: null
    },
    tiposSolicitacoes: {
        type: Array,
        required: true
    },
})

const emit = defineEmits(['update:modelValue', 'change']);

const { carregarTiposSolicitacoesProjetos, listaTiposSolicitacoesProjetos } = useBasicosProjetos();

const options = computed(() => {
    return listaTiposSolicitacoesProjetos.value.filter(tipo => props.tiposSolicitacoes.includes(tipo.nome));
});

const tipoSelecionado = ref();

watch(
    () => props.modelValue,
    async (newValue) => {
        if (newValue && newValue !== tipoSelecionado.value?.id) {
            await carregarTiposSolicitacoesProjetos();
            tipoSelecionado.value = options.value.find(rubrica => rubrica.id === newValue) || null;
        }
    },
    { immediate: true }
);

watch(
    () => tipoSelecionado.value,
    (newValue) => {
        emit('update:modelValue', newValue?.id);
        emit('change', newValue);
    }
);

onMounted(async () => {
    await carregarTiposSolicitacoesProjetos();
});
</script>

<template>
    <div class="field mb-2 col-12">
        <SmallTitle titulo="Tipo de Solicitação" :obrigatorio="true" />
        <Dropdown :options="options" v-model="tipoSelecionado" optionLabel="nome"
            emptyFilterMessage="Nenhum tipo de solicitação encontrada" :class="{ 'p-invalid': props.erro }"
            placeholder="Selecione o tipo de solicitação" :showClear="true">
        </Dropdown>
        <SmallError v-if="props.erro" :error="props.erro" />
    </div>
</template>